export default {
  init() {

  },
  finalize() {
    // Add to calendar toggle
    $('.event-calendar-btn').on('click', function() {
      $('.event-calendar-wrap').toggleClass('open');
    });

    // Click-off calendar
    $(window).on('click', function(e) {
      if (!$(e.target).hasClass('event-calendar-btn') && $(e.target).parents('.event-calendar-wrap').length == 0) {
        $('.event-calendar-wrap').removeClass('open');
      }
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/singleEvent.js